import { ItemTitle, PageTitle } from '@sleepstation/components'
import { VLayout } from '@sleepstation/components-layouts'
import { CopyRenderer } from '@sleepstation/components-markdown-renderer'
import { LAYOUT_SPACING } from '@sleepstation/const'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  spacing: [LAYOUT_SPACING.MEDIUM, LAYOUT_SPACING.X_LARGE],
})``

const Header = styled(VLayout).attrs({
  spacing: [LAYOUT_SPACING.SMALL, LAYOUT_SPACING.MEDIUM],
})``

const Footer = styled(VLayout).attrs({ spacing: LAYOUT_SPACING.SMALL })``
// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

// const Body = styled.div``
// <Body>
//       <ProgressChart
//         data={data}
//         config={{
//           aspect: 2,
//           showLegend: true,
//           xAxis: {
//             ticks: [0, 1, 2, 3, 4, 5, 6],
//           },
//         }}
//       />
//     </Body>

// eslint-disable-next-line no-unused-vars
const ChartSection = ({ title, bodyAst, data, footerTitle, footerBodyAst }) => (
  <Layout>
    <Header>
      <PageTitle>{title}</PageTitle>
      <CopyRenderer htmlAst={bodyAst} />
    </Header>

    <Footer>
      <ItemTitle>{footerTitle}</ItemTitle>
      <CopyRenderer dataCy="chartFooterForecast" htmlAst={footerBodyAst} />
    </Footer>
  </Layout>
)

ChartSection.propTypes = {
  title: PropTypes.string.isRequired,
  bodyAst: PropTypes.object.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  footerTitle: PropTypes.string.isRequired,
  footerBodyAst: PropTypes.object.isRequired,
}

export default ChartSection
